import { Id, TextField } from "@dgs/core";
import { ReactNode } from "react";
import { DataFieldIndexResource } from "../../types/dataField";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createNumberDataFieldContactAttributeBaseHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeBaseHandler {
	return {
		type: "NUMBER_DATA_FIELD",
		id,
		getLabel: () => dataField.label,
	};
}

export function createNumberDataFieldContactAttributeProfileHandler(
	id: Id,
	value: number | null,
	dataField: DataFieldIndexResource,
): IContactAttributeHandler<string, number | null> {
	const baseHandler = createNumberDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value !== null ? String(this.value) : "";
		},
		renderFormField(t, prefix): ReactNode {
			return (
				<TextField
					name={`${prefix ? `${prefix}.` : ""}${id}.value`}
					type="number"
					label={baseHandler.getLabel(t)}
					placeholder={dataField.placeholder}
					description={dataField.description}
				/>
			);
		},
		toRequestValue(): ContactAttributeRequest<string> {
			return { id, value: this.value !== null ? String(this.value) : "" };
		},
	};
}

export function createNumberDataFieldContactAttributeListHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeListHandler {
	const baseHandler = createNumberDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		getColumnSize: () => "1fr",
	};
}
